import { SearchOutlined } from "@ant-design/icons"
import { Form } from "antd"
import { SearchIcon } from "lucide-react"
import { useTranslation } from "react-i18next"

import ButtonPrimary from "~/components/base-button"
import BaseInput from "~/components/base-input"
import { validateNameOrLinkedinUrl } from "~/utils/url-validation"

import SearchCompanyImported from "./SearchCompany"

type SearchPanelProps = {
  form: any
  formError: boolean
  linkedinSearch: boolean
  initialValues: any
  handleSubmit: (values: any) => void
  handleValuesChange: (changedValues: any, values: any) => void
  SearchSeniorities: (props: { disabled: boolean }) => JSX.Element
  SearchLocations: (props: { disabled: boolean }) => JSX.Element
}

const SearchPanel = ({
  form,
  formError,
  linkedinSearch,
  initialValues,
  handleSubmit,
  handleValuesChange,
  SearchSeniorities,
  SearchLocations
}: SearchPanelProps) => {
  const { t } = useTranslation("common")

  return (
    <div className="h-full overflow-y-auto p-4 border rounded-2xl border-solid border-[#d4dae3] bg-[whitesmoke] dark:border-border dark:bg-dark-1">
      <Form
        form={form}
        onFinish={handleSubmit}
        autoComplete="off"
        autoCapitalize="off"
        layout="vertical"
        className="flex flex-col gap-4"
        initialValues={initialValues}
        onValuesChange={handleValuesChange}
      >
        <Form.Item
          label={
            <span className={formError ? "text-red-500" : ""}>
              {t("pre_meeting_brief.label_search_by_name_or_linkedin_url")}
            </span>
          }
          name="search"
          className="mb-4"
          rules={[
            {
              required: true,
              message: t(
                "pre_meeting_brief.validation_please_enter_name_or_linkedin_url"
              )
            },
            {
              validator: (_: any, value: string) => {
                if (!value) return Promise.resolve()
                if (!validateNameOrLinkedinUrl(value.trim())) {
                  return Promise.reject(
                    t(
                      "pre_meeting_brief.validation_invalid_url_enter_linkedin_or_name"
                    )
                  )
                }
                return Promise.resolve()
              }
            }
          ]}
        >
          <BaseInput
            allowClear
            className="input-field custom-input h-36 search-key-execs w-1/3 !bg-[whitesmoke] dark:!bg-dark-1"
            placeholder={t(
              "pre_meeting_brief.placeholder_search_by_name_or_linkedin_url"
            )}
            style={{ flex: 1, overflow: "hidden" }}
            prefix={
              <SearchIcon
                className="w-4 h-4 dark:text-dark-6 text-dark-2"
                strokeWidth={1}
              />
            }
          />
        </Form.Item>
        <SearchCompanyImported
          formError={formError}
          disabled={linkedinSearch}
        />
        <SearchSeniorities disabled={linkedinSearch} />
        <SearchLocations disabled={linkedinSearch} />
        <Form.Item className="mt-auto mb-4 search-label" label=" ">
          <ButtonPrimary htmlType="submit" className="h-9 w-full">
            <SearchOutlined className="text-[20px] w-[20px] h-[20px]" />{" "}
            {t("pre_meeting_brief.cta_search")}
          </ButtonPrimary>
        </Form.Item>
      </Form>
    </div>
  )
}

export default SearchPanel
